import React from "react"
import "./GameCard.scss"
import RatingOrange from "./../assets/icons/star_org.png"
import RatingGray from "./../assets/icons/star_gray.png"
import {Link} from "react-router-dom"

function GameCard(props) {
    const {data} = props
    const rating = Array(5).fill(0).map((item, i) => (
        i <= 3 ? <img key={i} src={RatingOrange} alt="stars" className="mr-1" /> : <img key={i} src={RatingGray} alt="stars" className="mr-1" />
    ))
  return (
    <div className="card mb-3">
         <div className="card-content p-0">
                <div className="media">
                    <div className="media-left">
                        <figure className="image is-120x120">
                            <img src={data.gameImage} alt="Placeholder" />
                        </figure>
                    </div>
                    <div className="media-content">
                        <div className="content p-2">
                        <p className="title is-capitalized is-6 pb-2">{data.gameName}</p>
                        <p className="subtitle is-7">{data.gamePlayed}</p>
                        <div className="rating">
                            {rating}
                            <small className="has-text-weight-light">259 عدد المستخدمين</small>
                        </div>
                        <Link to={`/game/${data.id}`} className="button is-theme is-small custom-align">العب الان</Link>
                        </div>
                    </div>
                </div>
         </div>
    </div> 
  )
}

export default GameCard